import type { SVGProps } from 'react';
const SvgSensorWindow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#sensor_window_svg__a)">
      <path
        fill="currentColor"
        d="M18 4v16H6V4h12Zm0-2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2ZM7 19h10v-6H7v6Zm3-9h4v1h3V5H7v6h3v-1Z"
      />
    </g>
    <defs>
      <clipPath id="sensor_window_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSensorWindow;
